import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {getClasses} from '../../helpers/mergeStylesHelper'
import Lk from '../lk/Lk'
import LkHeader from '../lk/LkHeader'
import LkHeaderAppend from '../lk/LkHeaderAppend'
import LkBody from '../lk/LkBody'
import EntityList from '../EntityList'
import CheckboxInput from '../CheckboxInput'
import {colors} from '../../styles/colors'
import Button from '../Button'


const styles = {
  Root: {},
  CheckBoxText: {
    color: colors.black
  },
  CheckBoxRoot: {
    padding: '0 20px'
  },
  BodyBottom: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30
  }
}
const useStyles = makeStyles(styles)

export default function LkOperatorRequests(props) {
  const classes = getClasses(props.classes, useStyles(props), styles)

  const tableData = [
    {
      number: '1235-606',
      type: 'ЮЛ',
      status: 'Новое',
      requster: 'Кузнецов И.А.',
      role: 'Водитель'
    },
    {
      number: '1235-606',
      type: 'ЮЛ',
      status: 'Новое',
      requster: 'Кузнецов И.А.',
      role: 'Водитель'
    },
    {
      number: '1235-606',
      type: 'ЮЛ',
      status: 'Новое',
      requster: 'Кузнецов И.А.',
      role: 'Водитель'
    },
    {
      number: '1235-606',
      type: 'ЮЛ',
      status: 'Новое',
      requster: 'Кузнецов И.А.',
      role: 'Водитель'
    },
  ]

  return (
    <Lk classes={classes}>
      <LkHeader title={'оператор'} append={
        <LkHeaderAppend
          title='Личный кабинет'
          backLink={'/some'}
        />
      } />

      <LkBody activeTab={'requests'} type={'operator'}>
        <EntityList
          data={tableData}
          toolbarTopAppend={
            <CheckboxInput classes={{ Text: classes.CheckBoxText, Root: classes.CheckBoxRoot }}>
              Новые заявления
            </CheckboxInput>
          }
          toolbarButtonText={'Создать заявление'}
          columns={[
            {title: 'Номер заявления', field: 'number', align: 'center'},
            {title: 'Тип', field: 'type', align: 'center'},
            {title: 'Статус', field: 'status', align: 'center'},
            {title: 'Заявитель', field: 'requester', align: 'center'},
            {title: 'Роль', field: 'role', align: 'center'},
          ]}
        />

        <div className={classes.BodyBottom}>
          <Button text={'Обновить'} size={'big'} />
        </div>
      </LkBody>
    </Lk>
  )
}